export default {
  SUBMIT_IMPORTAR_DATOS: 'SUBMIT_IMPORTAR_DATOS',
  SUBMIT_IMPORTAR_DATOS_SUCCESS: 'SUBMIT_IMPORTAR_DATOS_SUCCESS',
  ABRIR_MODAL_IMPORTAR_DATOS: 'ABRIR_MODAL_IMPORTAR_DATOS',
  CERRAR_MODAL_IMPORTAR_DATOS: 'CERRAR_MODAL_IMPORTAR_DATOS',
  SUBIR_ARCHIVOS_IMPORTAR_DATOS: 'SUBIR_ARCHIVOS_IMPORTAR_DATOS'
}